import apiClient from '../api.js';

const resource = '/estudiante/homologacion';

const useEstudianteHomologacionApi = {
    getHomologados(id_sede){
        return apiClient.get(`${resource}/${id_sede}`);
    },

    aprobarHomologacion(id,data) {
        return apiClient.post(`${resource}/${id}`, data);
    },
    actualizarHomologacion(id, data) {
        return apiClient.put(`${resource}/${id}`, data);
    },
    getMateriasHomologacionDar(unicodigo, id_plan_estudio, id_sede) {
        return apiClient.get(`${resource}/dar/materia/${unicodigo},${id_plan_estudio},${id_sede}`);
    },
    insertarNotasHomologacionDar(data) {
        return apiClient.post(`${resource}/dar/materia`, data);
    },
    deleteNotaHomologacionDar(unicodigo, id_plan_estudio, id_materia, id_sede) {
        return apiClient.delete(`${resource}/dar/materia/${unicodigo},${id_plan_estudio},${id_materia},${id_sede}`);
    },
    listarPlanesDeEstudioHomologados(unicodigo, id_sede) {
        return apiClient.get(`${resource}/planEstudio/${unicodigo},${id_sede}`);
    },
    obtenerKardexHomologacion(unicodigo, id_plan_estudio, id_sede) {
        return apiClient.get(`${resource}/kardex/${unicodigo},${id_plan_estudio},${id_sede}`);
    },
    // Seguimiento curricular del plan ANTIGUO (notas en unicen.notahom). Vive
    // bajo `/academico` porque es el endpoint nuevo con SQL versionado en el
    // repo (modules/academico), a diferencia del resto de este archivo.
    // Responde { data: { semestres: [{ idsem, sem }], materias: [...] } }.
    obtenerSeguimientoPlanAntiguo(unicodigo, id_plan_estudio, id_sede) {
        return apiClient.get('/academico/homologacion/seguimiento', {
            params: { unicodigo, id_plan_estudio, id_sede },
        });
    },

}

export default useEstudianteHomologacionApi;